/** Query param used for Alamire TV video search (shareable URLs). */
export const SEARCH_QUERY_PARAM = 'search';

export const getSearchQueryFromLocation = (): string => {
  if (typeof window === 'undefined') {
    return '';
  }
  return new URLSearchParams(window.location.search).get(SEARCH_QUERY_PARAM) ?? '';
};

/**
 * Sets or removes the search param on the current URL without reloading.
 * Preserves path, hash, and all other query params.
 * Uses the same string as the search input (shareable / bookmarkable).
 */
export const replaceSearchQueryInCurrentUrl = (query: string): void => {
  if (typeof window === 'undefined') {
    return;
  }

  const url = new URL(window.location.href);

  if (query === '') {
    url.searchParams.delete(SEARCH_QUERY_PARAM);
  } else {
    url.searchParams.set(SEARCH_QUERY_PARAM, query);
  }

  const next = `${url.pathname}${url.search}${url.hash}`;
  window.history.replaceState(window.history.state, '', next);
};
